module.exports = __webpack_public_path__ + "static/media/integrations-nest.ab9051ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/integrations-nest.png
// module id = 264
// module chunks = 0